import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {NavController} from "@ionic/angular";
import {Plugins} from '@capacitor/core';
import {OfflineModeService} from "../../services/offline-mode.service";
import {Subscription} from 'rxjs';
import {MobileSettingsService} from "../../services/mobile-settings.service";

const { Network } = Plugins;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  status: boolean = true;
  statusStorage: boolean = true;
  offlineModeEnabled = true;
  private statusSub: Subscription;
  private settingsSub: Subscription;

  constructor(
    private authService: AuthService,
    private navCtrl: NavController,
    private offlineMode: OfflineModeService,
    private mobileSettings: MobileSettingsService
  ) { }
  @Input() title: string;
  @Input() compact = false;
  @Input() useCloseButton = false;
  @Input() showOfflineToggle = true;
  @Output() closed = new EventEmitter<void>();

  ngOnInit() {
    this.statusSub = this.offlineMode.statusStorage$.subscribe((status) => {
      this.statusStorage = status;
    });
    this.settingsSub = this.mobileSettings.settings$.subscribe((settings) => {
      this.offlineModeEnabled = settings.offline_mode_enabled;
    });
  }

  ngOnDestroy() {
    if (this.statusSub) {
      this.statusSub.unsubscribe();
    }
    if (this.settingsSub) {
      this.settingsSub.unsubscribe();
    }
  }

  onClose() {
    this.closed.emit();
  }

  offLine(statusStorage: boolean) {
    this.offlineMode.offLine(statusStorage);
  }

  logout() {
    var sta = Network.getStatus();
    sta.then((val) => {
      this.status = val.connected;
      if(this.status){
        this.authService.logout().subscribe((data) => {
          this.navCtrl.navigateRoot('/login');
        }, (error) => console.log(error));
      }else{
        this.navCtrl.navigateRoot('/login');
      }
    });

  }
}
